import React from "react";
import { useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { FEATURE_FLAGS, useFeatureFlag } from "~/config/ff";
import MyDashboard from "../MyDashboard/MyDashboard";
import GlobalEntitiesList from "~/components/global-entities/GlobalEntities";
import { UserRole } from "~/types/roles";

const LandingPage = () => {
  const { value: isMyDashboardFeatureEnabled } = useFeatureFlag(
    FEATURE_FLAGS.MY_DASHBOARD,
    false,
  );
  const role = useSelector((state) => state.login.role);

  // SUPER_ADMIN should land on Tenants page
  if (role === UserRole.SUPER_ADMIN) {
    return <Navigate to="/tenants" replace />;
  }

  return isMyDashboardFeatureEnabled ? <MyDashboard /> : <GlobalEntitiesList />;
};

export default LandingPage;
